export const formatCurrency = (amount: number, symbol = "৳") => {
  return `${symbol}${amount.toLocaleString("en-BD", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
};
